import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactQueryProvider } from '@/providers/react-query-provider';
import { ToastProvider } from '@/providers/toast-provider';
import {
  AdminRoutes,
  AdminSideNavigation,
} from '@/features/admin/navigation/containers/admin-side-navigation';
import { AuthContextProvider } from '@/hooks/use-auth';
import { NotificationsProvider } from '@/features/shared/notifications/provider';
import StatsDashboardContent from '@/features/admin/stats/components/stats-dashboard-content';
import { StatsFiltersProvider } from '@/features/admin/stats/hooks/use-stats-filters';

const StatsDashboardScreen = () => {
  return (
    <ReactQueryProvider>
      <ToastProvider />
      <AuthContextProvider>
        <NotificationsProvider>
          <StatsFiltersProvider>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="flex h-screen w-screen">
              <AdminSideNavigation tabToSet={AdminRoutes.Stats} />
              <div className="flex h-full flex-1 flex-col overflow-hidden px-7 pt-7">
                <StatsDashboardContent />
              </div>
            </div>
          </StatsFiltersProvider>
        </NotificationsProvider>
      </AuthContextProvider>
    </ReactQueryProvider>
  );
};

export default StatsDashboardScreen;
export { StatsDashboardScreen };
